import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { Link } from 'react-router-dom';
export function AboutPage() {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="pt-[64px] md:pt-[72px]" data-id="element-358">
      {/* SECȚIUNEA 1 — HERO DESPRE MINE */}
      <section className="bg-brand-beige section-padding relative overflow-hidden" data-id="element-359">
        <div className="container-custom" data-id="element-360">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-361">
            <div className="space-y-6" data-id="element-362">
              <span className="inline-block px-4 py-1.5 rounded-full bg-brand-coral/10 text-brand-coral font-montserrat font-bold text-[12px] tracking-wider uppercase" data-id="element-363">
                PSIHOLOGIE & DEZVOLTAREA COPILULUI
              </span>
              <h1 className="font-playfair text-[40px] md:text-[56px] font-bold text-brand-navy leading-tight" data-id="element-364">
                Cristina Geană
              </h1>
              <p className="font-montserrat font-medium text-[14px] md:text-[16px] text-brand-textSecondary uppercase tracking-wide leading-relaxed" data-id="element-365">
                Psiholog Clinician . Supraspecializată în Dezvoltarea și Terapia
                Copilului Mic . Formată în Analiza Comportamentală (ABA)
              </p>
              <div className="bg-white p-6 rounded-[16px] border-l-4 border-brand-gold shadow-sm mt-6" data-id="element-366">
                <p className="font-source text-[18px] text-brand-text italic" data-id="element-367">
                  "Nu sunt aici să îți dau soluții rapide sau rețete magice.
                  Sunt aici pentru că știu cât de greu e să cauți răspunsuri
                  pentru copilul tău și să nu știi de unde să începi. Și pentru
                  că am văzut ce se întâmplă când o mamă primește ghidarea
                  potrivită."
                </p>
              </div>
            </div>
            <div className="relative h-[500px] md:h-[600px] rounded-[24px] overflow-hidden shadow-card" data-id="element-368">
              <img src="https://cdn.magicpatterns.com/uploads/wvUBHAy6VhqaRqNiVJPB6X/Cristina_poze_%285%29.jpg" alt="Cristina Geană" className="w-full h-full object-cover" data-id="element-369" />
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 2 — DE CE FAC CE FAC */}
      <section className="bg-brand-ivory section-padding" data-id="element-370">
        <div className="container-custom" data-id="element-371">
          <div className="max-w-3xl mx-auto text-center space-y-8" data-id="element-372">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy" data-id="element-373">
              De ce am ales să lucrez cu mamele de copii mici
            </h2>
            <div className="font-source text-[18px] text-brand-text space-y-6 text-left" data-id="element-374">
              <p data-id="element-375">
                Multe mame care ajung la mine au trecut deja prin tot: cursuri
                care nu au funcționat, ghiduri descărcate de pe internet,
                sfaturi de la apropiați care le spun că "exagerează". Și totuși,
                în interior, simt că ceva nu e în regulă cu copilul lor.
              </p>
              <div className="text-center py-6" data-id="element-376">
                <p className="font-playfair text-[24px] text-brand-coral italic" data-id="element-377">
                  "Când cauți răspunsuri peste tot și nu găsești pe nimeni care
                  să te înțeleagă cu adevărat, începi să crezi că problema ești
                  tu."
                </p>
              </div>
              <p data-id="element-378">
                Am ales să fac ce fac pentru că am văzut cum arată confuzia și
                frica din ochii unei mame care nu știe dacă copilul ei se
                dezvoltă normal. Și am văzut cum se transformă totul atunci când
                primește un plan clar, sprijin real și pe cineva care o ascultă
                fără să o judece.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 3 — MISIUNEA MEA */}
      <section className="bg-brand-navy section-padding text-white" data-id="element-379">
        <div className="container-custom" data-id="element-380">
          <div className="max-w-4xl mx-auto" data-id="element-381">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-white text-center mb-12" data-id="element-382">
              Ghidare către încredere și claritate ca mamă
            </h2>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12" data-id="element-383">
              {['De la îngrijorare și confuzie, la claritate și încredere', 'De la căutare fără rost, la un plan clar pas cu pas', 'De la "nu știu ce să fac" la "știu exact cum să îl ajut"'].map((item, i) => <div key={i} className="bg-white/10 backdrop-blur-sm p-6 rounded-[16px] border border-white/20 text-center" data-id="element-384">
                  <p className="font-source text-[16px] text-white font-medium" data-id="element-385">
                    {item}
                  </p>
                </div>)}
            </div>

            <div className="font-source text-[18px] text-white/90 space-y-6" data-id="element-386">
              <p data-id="element-387">
                Ghidez mamele de copii între 1 și 4 ani care nu vorbesc sau
                vorbesc prea puțin să își ajute copiii să se dezvolte armonios,
                prin joc și conectare, folosind rutine zilnice simple, fără
                jucării scumpe și tehnici complicate.
              </p>
              <p data-id="element-388">
                Cred că un copil, ca să poată vorbi și să producă gândire
                autentică, are nevoie să se dezvolte pe toate ariile
                dezvoltării. Limbajul nu se dezvoltă izolat și nu poate fi
                tratat izolat.
              </p>
              <p data-id="element-389">
                Tocmai de aceea Programul CRESC acoperă tot ce are nevoie
                copilul tău: cunoaștere, relaționare, emoții, comunicare și
                autonomie.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 4 — ACREDITĂRI & FORMARE PROFESIONALĂ */}
      <section className="bg-brand-beige section-padding" data-id="element-390">
        <div className="container-custom" data-id="element-391">
          <div className="max-w-4xl mx-auto" data-id="element-392">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy text-center mb-6" data-id="element-393">
              Acreditări & Formare Profesională
            </h2>
            <p className="font-source text-[18px] text-brand-textSecondary text-center mb-12 max-w-2xl mx-auto" data-id="element-394">
              Lucrez într-un cadru profesional validat, cu instrumente bazate pe
              dovezi științifice și cu peste 11 ani de experiență directă cu
              copii mici și familiile lor.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-395">
              {['Psiholog Clinician atestat, membru al Colegiului Psihologilor din România (din 2015), treapta Psiholog Autonom', 'Facultatea de Psihologie, Universitatea Spiru Haret, Brașov (2013)', 'Master în Psihoterapii Cognitiv-Comportamentale, Universitatea Titu Maiorescu, București (2015)', 'Curs de lungă durată în Psihologie Clinică (2018)', 'Curs de lungă durată în Analiză Comportamentală (ABA), Universitatea Clemson, SUA (2021)', 'Neurotrainer Neurofeedback ILF (2022) și NeurOptimal (2023)'].map((cert, i) => <div key={i} className="bg-white p-6 rounded-[16px] shadow-sm flex items-start gap-4" data-id="element-396">
                  <CheckCircle2Icon className="text-brand-gold flex-shrink-0 mt-1" size={24} data-id="element-397" />
                  <p className="font-source text-[16px] text-brand-text" data-id="element-398">
                    {cert}
                  </p>
                </div>)}
            </div>
          </div>
        </div>
      </section>

      {/* SECȚIUNEA 5 — CTA FINAL */}
      <section className="bg-brand-ivory section-padding text-center" data-id="element-399">
        <div className="container-custom" data-id="element-400">
          <div className="max-w-3xl mx-auto" data-id="element-401">
            <h2 className="font-playfair text-[32px] md:text-[40px] font-bold text-brand-navy mb-6" data-id="element-402">
              Vrei să știi dacă ești pe drumul cel bun cu copilul tău?
            </h2>
            <p className="font-source text-[18px] text-brand-textSecondary mb-8" data-id="element-403">
              Descarcă ghidul gratuit și primești primele instrumente practice
              cu care poți începe să lucrezi acasă, chiar de azi. Sau, dacă
              simți că ai nevoie de un răspuns clar despre dezvoltarea copilului
              tău, programează o evaluare online.
            </p>
            <div className="flex flex-col items-center gap-3" data-id="element-404">
              <Link to="/resursegratuite" className="btn-primary" data-id="element-405">
                Descarcă Ghidul Gratuit
              </Link>
              <p className="font-source text-[14px] text-brand-textSecondary" data-id="element-406">
                Evaluarea online se desfășoară pe Zoom și primești raportul în
                48 de ore.
              </p>
            </div>
          </div>
        </div>
      </section>
    </motion.div>;
}